import React from "react"
import Loader from "../ui/loader"
import { Label } from "../ui/label"
import { Switch } from "../ui/switch"
import {
  SvgEdit,
  SvgShare,
  SvgTrash,
  SvgArchive,
  SvgSettings,
  SvgCopy,
} from "../icons"

interface Props {
  loadingToggleChange: boolean
  isServiceVisible: boolean
  updateServiceProfileVisibility: () => void
  service: any
  service_details: any
  setUpdateService: (args: any) => void
  setIsGroupService: (val: boolean) => void
  copyShareLink: () => void
  deleteService: () => void
  unarchiveService: () => void
  showArchiveModal: () => void
  setShowDuplicateService: (args: any) => void
  dropdownRef: React.RefObject<HTMLDivElement>
  isDropdownOpen: boolean
  setIsDropdownOpen: (val: boolean) => void
}

const ServiceVisibilityButtons: React.FC<Props> = ({
  loadingToggleChange,
  updateServiceProfileVisibility,
  isServiceVisible,
  service_details,
  setUpdateService,
  setIsGroupService,
  service,
  copyShareLink,
  dropdownRef,
  isDropdownOpen,
  setIsDropdownOpen,
  deleteService,
  setShowDuplicateService,
  showArchiveModal,
  unarchiveService,
}) => {
  return (
    <>
      <div className="relative sm:px-10 flex flex-col sm:gap-4 z-[50]">
        <div className="flex w-full items-center justify-between p-2 rounded">
          <p className="font-bold text-base">Service Visibility</p>
          <div className="flex items-center gap-2">
            <Label htmlFor="service-visible">Private</Label>
            {loadingToggleChange ? (
              <Loader />
            ) : (
              <Switch
                id="service-visible"
                onCheckedChange={updateServiceProfileVisibility}
                checked={isServiceVisible}
                onClick={(e) => e.stopPropagation()}
              />
            )}
            <Label htmlFor="service-visible">Public</Label>
          </div>
        </div>

        <div className="p-4 sm:p-0 flex items-center justify-between gap-2 mb-2 -mt-4 sm:-mt-0">
          {["active", "inactive"].includes(service_details?.status) ? (
            <>
              <button
                className="btn-primary btn-secondary gap-2 md:w-[110px]"
                onClick={(e) => {
                  e.stopPropagation()
                  setUpdateService({
                    serviceType: service_details?.type,
                    show: true,
                    service: service,
                    source: "MyServices",
                  })
                  setIsGroupService(service_details?.isGroupService)
                }}
              >
                Edit
                <SvgEdit />
              </button>

              {service_details?.status === "active" && (
                <button
                  className="btn-primary btn-secondary gap-2 md:w-[110px]"
                  onClick={(e) => {
                    e.stopPropagation()
                    copyShareLink()
                  }}
                >
                  Share
                  <SvgShare />
                </button>
              )}

              <div className="relative z-[50]" ref={dropdownRef}>
                <button
                  className="btn-primary btn-secondary gap-2 md:w-[110px]"
                  onClick={(e) => {
                    e.stopPropagation()
                    setIsDropdownOpen(!isDropdownOpen)
                  }}
                >
                  More <SvgSettings fill="black" height={22} />
                </button>

                {isDropdownOpen && (
                  <div className="absolute right-0 mt-2 p-2 bg-white border shadow-md rounded-md">
                    <button
                      className="flex items-center gap-2 text-[red] px-3 py-2 hover:bg-gray-100 rounded-md"
                      onClick={(e) => {
                        e.stopPropagation()
                        deleteService()
                      }}
                    >
                      Delete
                      <SvgTrash />
                    </button>
                    {service?.service_details.type !== "consultation" && (
                      <button
                        className="flex items-center gap-2 text-blue-500 px-3 py-2 hover:bg-gray-100 rounded-md"
                        onClick={(e) => {
                          e.stopPropagation()
                          setShowDuplicateService({ show: true, service })
                        }}
                      >
                        Duplicate
                        <SvgCopy />
                      </button>
                    )}
                    <button
                      className="flex items-center gap-2 text-blue-500 px-3 py-2 hover:bg-gray-100 rounded-md"
                      onClick={(e) => {
                        e.stopPropagation()
                        showArchiveModal()
                      }}
                    >
                      Archive
                      <SvgArchive />
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <button
                className="btn-primary btn-secondary gap-[10px] w-[140px]"
                onClick={(e) => {
                  e.stopPropagation()
                  unarchiveService()
                }}
              >
                Unarchive
                <SvgArchive />
              </button>
              <button
                className="btn-primary btn-secondary gap-[10px] w-[140px]"
                onClick={(e) => {
                  e.stopPropagation()
                  deleteService()
                }}
              >
                Delete
                <SvgTrash />
              </button>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default ServiceVisibilityButtons
